import { render, staticRenderFns } from "./ApplyGradeFrom.vue?vue&type=template&id=536df815&"
import script from "./ApplyGradeFrom.vue?vue&type=script&lang=js&"
export * from "./ApplyGradeFrom.vue?vue&type=script&lang=js&"
import style0 from "./ApplyGradeFrom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports